import React from 'react';

const ModalFullscreenLayout = ({ children }: { children: React.ReactNode }) => {
  return (
    <div className="tw-h-screen tw-w-screen tw-bg-cfo-black/30 tw-fixed tw-top-0 tw-bottom-0 tw-z-20 tw-flex tw-items-center tw-justify-center">
      {children}
    </div>
  );
};

export default ModalFullscreenLayout;
